import { PendingPageTemplate } from "./template";

export const PendingPage = (): JSX.Element => {
    return (
        <PendingPageTemplate />
    )
    
}